import Vue from 'vue'

const state = {
  offset: {
    x: 500,
    y: 200
  },
  soso: {
    searchText:'',
    priceOrder: false,
    orderType: false,
    page: 1,
    size: 16
  },
  loadingDh: false,
  addLoading: '',
  LoadingCart: false,
  LoadingScroll: false,
  cartList: {
    products:[],
    size:8,
    total:1,
    totalPage:1,
  },
  carts:{
    cartDetails:[]
  },
  shopInfo:{
    merchantName:'',
    merchantCode:'',
    productVOs:{
      topPicture:0
    }
  },
  productsDetail:{
    quantity:0
  },
  addCarts:{
    cartDetails:[]
  },
  adrList: [],
  submit:{},
  areas:[],
  region: [],
  city: [],
  userInfo:{
    customName: '',
    creatTime: ''
  }
}
const getters = {
  offset: state => state.offset,
  LoadingCart: state => state.LoadingCart,
  loadingDh: state => state.loadingDh,
  cartList: state => state.cartList,
  carts: state => state.carts,
  shopInfo: state => state.shopInfo,
  productsDetail: state => state.productsDetail,
  addCarts: state => state.addCarts,
  addLoading: state => state.addLoading,
  adrList: state => state.adrList,
  submit: state => state.submit,
  LoadingScroll: state => state.LoadingScroll,
  areas: state => state.areas,
  region: state => state.region,
  city: state => state.city,
  user: state => state.userInfo
}

const mutations = {
  OFFSET (state, m) {
    state.offset = m
  },
  LOADINGCART (state, m) {
    state.LoadingCart = m
  },
  LOADINGDH (state, m) {
    state.loadingDh = m
  },
  ADDLOADING (state, m) {
    state.addLoading = m
  },
  CARTLIST(state, m) {
    state.cartList = m
  },
  CARTS(state, m) {
    state.carts = m
  },
  REQUEST_CONFIG_SO (state, list) {
    state.soso.searchText = list
  },
  PRICE_SO (state, list) {
    state.soso.priceOrder = list
  },
  ORDER_SO (state, list) {
    state.soso.orderType = list
  },
  CURRENT_PAGE (state, list) {
    state.soso.page = list
  },
  LOAGING_SCROLL (state, list) {
    state.LoadingScroll = list
  },
  MESSAGE_LIST_SCROLL (state, list) { // 上拉加载
    state.cartList.products = state.cartList.products.concat(list.products)
  },
  PUTCARTS(state, o) {
    // 更新列表商品数量
    state.cartList.products.forEach((v, idx) => {
      if (o.productCode === v.productCode) {
        v.quantity = o.quantity
        state.cartList.products.splice(idx, 1, Object.assign({}, v))
      }
    })
  },

  DELCARTS(state, o) {
    // 删除购物车
    if (o.tag != 'one') {
      state.productsDetail.quantity = 0
    }
    state.carts.cartDetails.forEach((v, idx) => { if (o.productCode === v.productCode) state.carts.cartDetails.splice(idx, 1) })
  },
  ALLDELCARTS(state, m) {
    state.productsDetail.quantity = 0
    state.carts.cartDetails = m
    state.cartList.products.length > 0 && state.cartList.products.forEach((v, idx) => {
        v.quantity = 0
        state.cartList.products.splice(idx, 1, Object.assign({}, v))
    })
  },
  SHOPINFO(state, m) {
    state.shopInfo = m
  },
  PRODUCTSDETAIL(state, m) {
    state.productsDetail = m
  },
  ADDCARTS(state, o) {
    // 添加 更新 到购物车
    var list 
    if (o.tag == 'one') {
      list = state.cartList.products.find((item) => o.productCode === item.productCode) // 列表页 单条数据
    } else {
      list = state.productsDetail // 详细页 单条数据
    }
    
    var isCode = state.carts.cartDetails.find((item) => o.productCode === item.productCode) // 过虑重复添加
    if (isCode === undefined) { // 购物车 添加一条
      list.quantity = o.quantity
      state.carts.cartDetails.unshift(list)
    } else { // 购物车 更新一条

      JSON.parse(JSON.stringify(state.carts.cartDetails)).forEach((item, idx) => {
        if (o.productCode === item.productCode) {
          item.quantity = o.quantity
          list.quantity = o.quantity // 更新 列表 或 详细
          state.carts.cartDetails.splice(idx, 1, Object.assign({}, item)) // 更新 购物车
        }
      })

    }
  },

  ADRLIST(state, m) {
    state.adrList = m
  },

  SUBMIT(state, m) {
    state.submit = m
  },

  AREAS(state, m) {
    state.areas = m
  },

  REGION(state, m) {
    state.region = m
  },

  CITY(state, m) {
    state.city = m
  },

  USER_INFO(state, m) {
    state.userInfo = m
  }
}

function funCartNum (c, v) {
  var p = v.products;
  Array.isArray(p) && p.length > 0 && p.forEach(k => {
    k.quantity = 0
    Array.isArray(c) && c.length > 0 && c.forEach((item) => { // 购物车数量同步
      if (k.productCode == item.productCode) {
        k.quantity = item.quantity
        k.stock = item.stock
      }
    })
  })
  return v
}

const actions = {
  OFFSET ({ commit }, m) {
    commit('OFFSET', m)
  },

  LOADINGDH ({ commit }, m) {
    commit('LOADINGDH', m)
  },

  SHOPINFO ({ commit}, merchantCode) {
    // 店铺信息
    Vue.http.get(Vue.conf.Api.apis + `/client/v1/points/${merchantCode}/shopInfo`).then((res)=>{
      if (res.data.recode == 200) commit('SHOPINFO', res.data.shopPointVO)
    })
  },

  PLIST ({ commit, state}) {
    // soso列表
    commit('LOADINGCART',true)
    Vue.http.get(Vue.conf.Api.apis + `/client/v1/${state.shopInfo.merchantCode}/products/`,{params: state.soso}).then((res)=>{
      commit('LOADINGCART',false)
      if (res.data.recode == 200) {
        let cart = state.carts, product = res.data
        product = funCartNum(cart.cartDetails, product)
     
        commit('CARTLIST', product)
      }
    })
  },

  MESSAGE_LIST_DPH_SCROLL ({ commit, state }) { // 下拉加载
    commit('LOAGING_SCROLL', true)
    Vue.http.get(Vue.conf.Api.apis + `/client/v1/${state.shopInfo.merchantCode}/products/`,{params: state.soso}).then(function (res) {
      commit('LOAGING_SCROLL', false)
      if (res.data.recode == 200) {
        let cart = state.carts, product = res.data
        product = funCartNum(cart.cartDetails, product)
        
        commit('MESSAGE_LIST_SCROLL', product)
      }
    })
  },

  LOGIN_INFO ({ commit}) {
    // 用户信息
    Vue.http.get(Vue.conf.Api.apis + Vue.conf.Api.userInfo).then((userInfo)=>{
      if(userInfo.data.recode == 200){
        commit('USER_INFO', userInfo.data.user)
        Vue.storage.setLs( 'userinfo', userInfo.data.user)
      }
    })
  },

  ALLCARTS({ commit,state }, merchantCode) {
    // 购物车初始化
    let obj = {
      cartList: Vue.http.get(Vue.conf.Api.carts,{params:{merchantCode: merchantCode}}),
      productsList: Vue.http.get(Vue.conf.Api.apis + `/client/v1/${merchantCode}//products/`,{params: state.soso}),
      shopInfo: Vue.http.get(Vue.conf.Api.apis + `/client/v1/points/${merchantCode}/shopInfo`)
    }
    commit('LOADINGCART',true)
    Vue.http.all([obj.shopInfo, obj.cartList, obj.productsList,obj.userInfo]).then(Vue.http.spread( (shopInfo, cartList, productsList) => {
        commit('LOADINGCART',false)
        let cart = cartList.data.cart, product = productsList.data
        product = funCartNum(cart.cartDetails, product)

        if(shopInfo.data.recode == 200){
          commit('SHOPINFO', shopInfo.data.shopPointVO)
          Vue.storage.setLs( 'shopinfo', shopInfo.data.shopPointVO)
        }
        
        commit('CARTS', cart.cartDetails && cart || {cartDetails:[]} )
        commit('CARTLIST',  product )
    }))
  },

  ALLCHECKOUT({ commit }, merchantCode) {
    // 确认订单初始化
    let obj = {
      cartList: Vue.http.get(Vue.conf.Api.carts,{params:{merchantCode: merchantCode}}),
      addr: Vue.http.get(Vue.conf.Api.apis + `/client/v1/addresses`),
      shopInfo: Vue.http.get(Vue.conf.Api.apis + `/client/v1/points/${merchantCode}/shopInfo`)
    }
    commit('LOADINGCART',true)
    Vue.http.all([obj.shopInfo, obj.cartList,obj.addr]).then(Vue.http.spread( (shopInfo, cartList, addr) => {
        commit('LOADINGCART',false)
        let cart = cartList.data.cart, addrs = addr.data.addresses
        shopInfo.data.recode == 200 && commit('SHOPINFO', shopInfo.data.shopPointVO)
        commit('CARTS', cart.cartDetails && cart || {cartDetails:[]} )
        addrs && commit('ADRLIST', addrs)
        
    }))
  },

  PRODUCTSDETAIL({ commit}, o) {
    // 详细
    Vue.http.get(Vue.conf.Api.apis + `/client/v1/${o.merchantCode}/products/${o.id}`).then((res)=>{
      if (res.data.recode == 200) commit('PRODUCTSDETAIL', res.data.product)
    })
  },

  ALLPRODUCTSDETAIL({ commit }, o) {
    // 详细页初始化
    let obj = {
      cartList: Vue.http.get(Vue.conf.Api.carts,{params:{merchantCode: o.merchantCode}}),
      products: Vue.http.get(Vue.conf.Api.apis + `/client/v1/${o.merchantCode}/products/${o.id}`),
      shopInfo: Vue.http.get(Vue.conf.Api.apis + `/client/v1/points/${o.merchantCode}/shopInfo`)
    }
    commit('LOADINGCART',true)
    Vue.http.all([obj.shopInfo, obj.cartList,obj.products]).then(Vue.http.spread( (shopInfo, cartList, products) => {
        commit('LOADINGCART',false)
        commit('SHOPINFO', shopInfo.data.shopPointVO)

        let cart = cartList.data.cart, product = products.data.product
        if (products.data.recode == '200' && Array.isArray(cart.cartDetails) && cart.cartDetails.length > 0) {
          cart.cartDetails.forEach((item) => { // 数量同步
              if (product.productCode == item.productCode) {
                product.quantity = item.quantity
              }
          })
        }

        commit('CARTS', cart.cartDetails && cart || {cartDetails:[]} )
        products.data.recode == '200' ? commit('PRODUCTSDETAIL', product) : commit('PRODUCTSDETAIL', {quantity:0})
        
    }))
  },

  SUBMIT({ commit }, o) {
    // 提交订单
    commit('LOAGING_SCROLL',true)
    return new Promise((resolve) => {
      Vue.http({
        method: `POST`,
        headers: {'Content-Type': 'application/json'},
        url: Vue.conf.Api.submitCart,
        data: o
      }).then(function (res) {
        resolve(res)
        commit('LOAGING_SCROLL',false)
        commit('SUBMIT',res.data)
      })
    })
  },

  ADDCARTS({ commit }, o) {
    // 添加购物车
    commit('ADDLOADING', o.productCode)
    return new Promise((resolve) => {
      Vue.http({
        method: `POST`,
        url: Vue.conf.Api.carts,
        data: o,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(function (res) {
        resolve(res)
        commit('ADDLOADING', '')
        if (res.data.recode == 200) {
            commit('ADDCARTS', o)

            commit('LOADINGDH', true)
            setTimeout(function () {
              commit('LOADINGDH', false )
            }, 300)

          }
          
      })

    })
  },

  PUTCARTS({ commit }, o) {
    // 更新购物车
    commit('ADDLOADING', o.productCode)
    return new Promise((resolve) => {
      Vue.http.put(Vue.conf.Api.carts + '?merchantCode=' + o.merchantCode + '&productCode=' + o.productCode +'&quantity=' + o.quantity).then((res)=>{
        commit('ADDLOADING', '')
        resolve(res)
        if (res.data.recode == 200) {
          commit('PUTCARTS', o)
          commit('ADDCARTS', o)

          if (o.animation == 'add') {
            commit('LOADINGDH', true)
            setTimeout(function () {
              commit('LOADINGDH', false )
            }, 300)
          }

        }
      })
    })
  },

  DELCARTS({ commit }, o) {
    // 单个删除购物车商品
    commit('ADDLOADING', o.productCode)
    return new Promise((resolve) => {
      Vue.http.delete(Vue.conf.Api.delCart + '?merchantCode=' + o.merchantCode,{data:[o.productCode]}).then((res)=>{
        commit('ADDLOADING', '')
        resolve(res)
        if (res.data.recode == 200) {

          commit('DELCARTS', o)
          commit('PUTCARTS', o)

        }
      })
    })
  },

  ALLDELCARTS({ commit }, merchantCode) {
    // 清空购物车商品
    Vue.http.delete(Vue.conf.Api.delCart + '?merchantCode=' + merchantCode,{data:[]}).then((res)=>{
      if (res.data.recode == 200) {
        commit('ALLDELCARTS',[])
      }
    })
  },

  ALLDELNOCARTS({ commit },o) {
    // 清空购物车失效商品
    return new Promise((resolve) => {
      Vue.http.delete(Vue.conf.Api.delCart + '?merchantCode=' + o.merchantCode,{data:o.list}).then((res)=>{
        resolve(res)
        if (res.data.recode == 200) {
          // commit('ALLDELCARTS',[])
        }
      })
    })
  },

  ADDRLIST ({ commit}) {
    // 地址列表
    Vue.http.get(Vue.conf.Api.apis + `/client/v1/addresses`).then((addr)=>{
      if (addr.data.recode == 200) commit('ADRLIST', addr.data.addresses)
    })
  },

  ADDRDEFAULT({ commit },id) {
    // 地址设为默认
    return new Promise((resolve) => {
      Vue.http.patch(Vue.conf.Api.addrDefault + id).then(function (res) {
        resolve(res)
      })
    })
  },

  ADD_DEFAULT({ commit },o) {
    // 添加地址
    return new Promise((resolve) => {
      Vue.http({
        method: `POST`,
        url: Vue.conf.Api.addrDefault,
        data: o,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then(function (res) {
        resolve(res)
      })
    })
  },

  PUT_ADDR({ commit },o) {
    // 修改地址
    return new Promise((resolve) => {
      Vue.http({
        method: `PUT`,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        url: Vue.conf.Api.addrDefault + o.id,
        data: o,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }]
      }).then((res)=>{
        resolve(res)
      })
    })
  },

  AREAS ({ commit}) {
    // 省
    Vue.http.get(Vue.conf.Api.areas).then((addr)=>{
      const areas = addr.data.area
      if (addr.data.recode == 200) commit('AREAS', areas.map( item => { return { name:item.region, id:item.regionId}} ))
    })
  },

  REGION ({ commit}, areasId) {
    // 市
    Vue.http.get(Vue.conf.Api.region + areasId).then((addr)=>{
      const area = addr.data.area
      if (addr.data.recode == 200) commit('REGION', area.map( item => { return { name:item.city, id:item.cityId}} ))
    })
  },

  CITY ({ commit}, o) {
    // 区
    Vue.http.get(Vue.conf.Api.city + o.regionId +'/' + o.cityId).then((addr)=>{
      const area = addr.data.area
      if (addr.data.recode == 200) commit('CITY', area.map( item => { return { name:item.county, id:item.countyId}} ))
    })
  },
  

}

export default {
  state,
  getters,
  mutations,
  actions
}
